module.exports = __webpack_public_path__ + "static/media/taxi_logo.6f64c917.png";